<template>
  <section class="section">
    <div class="content">
      <h1 class="title">
        Hebrew Meanings for Numbers
      </h1>

      <p>
        <back-button />
      </p>
    </div>

    <div class="columns">
      <div class="column">
        <div class="field has-addons">
          <div class="control is-expanded">
            <input class="input" type="number" @keyup.enter="search()" v-model="gematricValue" placeholder="Enter a number to search for words">
          </div>
          <div class="control">
            <a class="button is-info" @click="search()">
              Search
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-for="word in results" v-bind:key="word.id">
      <div class="card-content content">
        <h2 class="rtl">{{ word.translated }}</h2>
        <h3 v-if="false && word.part_of_speech">As in “<span class="rtl">{{ word.part_of_speech }}</span>”</h3>
        <ul>
          <li v-for="translation in word.translation" :key="translation">{{ translation }}</li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import dictionaryHebrewEnglish from '@/vendor/gregarkhipov/milon/dict-he-en.json'
import { gematria } from '@/hebrew'
import BackButton from '@/components/pages/BackButton'

export default {
  components: {
    BackButton
  },
  data () {
    return {
      gematricValue: '',
      results: []
    }
  },
  methods: {
    search () {
      this.results = []

      if (!this.gematricValue || !parseInt(this.gematricValue, 10)) {
        return
      }

      const gematricValue = parseInt(this.gematricValue, 10)
      for (let word of dictionaryHebrewEnglish) {
        const dictWord = word.translated.replace(/[\u0591-\u05C7]/g, '')
        if (gematria(dictWord) === gematricValue) {
          this.results.push(word)
        }
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.rtl
  direction: rtl
  text-align: left
</style>



// WEBPACK FOOTER //
// src/components/pages/HebrewReverseGematriaPage.vue